import Vue from "vue";
import App from "./App.vue";
// 常量
import OutConst from "./customEventOutConst.js";
import InConst from "./customEventInConst.js";
import CONSTNAME from "@/ConstName.js";
Vue.prototype.$outConst = OutConst;
Vue.prototype.$inConst = InConst;
Vue.prototype.$const = CONSTNAME;

// 全局·组件 + 过滤器
import "element-ui/lib/theme-chalk/index.css";
import components from "./global/components";
Vue.use(components);
import filters from "./global/filters";
Vue.use(filters);
// Mock
// process.env.NODE_ENV == "development" && require("@/mock/mock.js");
// import "./mock/mock.js";

import axios from "axios";
Vue.prototype.$axios = axios;
// Vuex
import createStore from "./store/index.js";
// 全局·工具方法
import * as utils from "@/utils/ganttUnit.js";
Vue.prototype.$utils = utils;
import chaining from "@/utils/chaining";
Vue.use(chaining);
// 右菜单
import Contextmenu from "vue-contextmenujs";
Vue.use(Contextmenu);

import { name, version, description, iteration, author, lastTime } from "../package.json";
console.log(
  `名称: %c${name}`,
  "color:red;font-weight:bold;",
  `\n版本: ${version}\n功能: ${description}\n迭代: ${iteration}\n开发: ${author}\n环境: ${process.env.NODE_ENV}\n时间: ${lastTime}`,
);

// 在main.js上通过import引入Vue库和自己写的Vue组件库
/**
 * Vue实例在setHtml方法中声明，初始化执行init的时候就能够创建
 * 声明Vue实例对象时，在其挂载完毕的生命周期里声明一个订阅，用于订阅update方法中发布的消息，从而更新实例数据
 * update方法中，发布一个消息，让Vue实例接收消息，更新数据
 * 在Vue实例的destroyed中，结束订阅
 * 注意loadFile中index.css的引入路径，因为webpack打包后将其放在了css文件夹里，所以路径是./css/index.css
 */
// eslint-disable-next-line no-unexpected-multiline
(function(KDApi) {
  function MyComponent(model, props) {
    this._setModel(model);
  }

  // 交互响应
  const callBack = function(model, props, _store) {
    _store.state.dataLoadingStatus && _store.commit("set_dataLoadingStatus", false); // 关闭数据加载态

    const paramsMap = props.data;
    if (!paramsMap && typeof paramsMap != "object" || paramsMap == null) return;
    if (!paramsMap.success) return;
    const action = paramsMap.methodName;
    console.log("苍穹参数:", paramsMap);
    /* const _uuid = model.pageId + "_" + model.key;
    const _vm = window[_uuid]; */
    if (action == InConst.DATA_LOADING) { // 初始化·主动发起数据加载
      _store.commit("set_dataLoadingStatus", true);
      _store.dispatch(OutConst.CUSTOM_INIT);

    } else if (action == InConst.INIT_APP) { // 初始化·刷新数据
      _store.commit("set_data", paramsMap.data);
    }
    model.invoke(OutConst.RESET_STATUS, model.schemaId);
  };

  /* 监听容器 */
  function addResizeObserve(element, callback) {
    const handleResize = (entries) => {
      const entry = entries[0];
      const { width, height } = entry.contentRect;
      const hide = width === 0 && height === 0;
      const rect = { hide, width, height };
      // console.log("entry.target", entry.target);
      // console.log("size", entry.contentRect);
      callback && callback(rect);
    };
    let watcher = new ResizeObserver(handleResize);
    watcher.observe(element);
    return {
      removeResizeObserve: function() {
        watcher.disconnect(element);
        watcher = null;
      },
    };
  }

  if (KDApi) {
    const setHtml = (model) => {
      // 实例化
      const { dom } = model;
      const _uuid = model.pageId + "_" + model.key;
      window[_uuid] = new Vue({
        el: dom,
        data: {
          resizeObj: null,
        },
        created() {
          this.$store.commit("setUuid", _uuid);
        },
        components: { App },
        template: `<App />`,
        methods: {
          resizeCb(info) {
            if (
              info.hide === true ||
              (
                info.width == this.$store.state.local.totalWidth
              )
            ) {
              return;
            }
            const { width } = info;
            this.$store.commit("set_totalWidth", width);
          },
        },
        store: window["_store_" + _uuid],
        mounted() {
          // console.log("初始化容器宽高");
          this.resizeObj = addResizeObserve(this.$el, this.resizeCb);
        },
        beforeDestroy() {
          if (this.resizeObj && this.resizeObj.removeResizeObserve) {
            this.resizeObj.removeResizeObserve();
            this.resizeObj = null;
            console.log("重置容器尺寸监听");
          }
        },
      });
    };
    const toolsInfoStyle1 = "color:#fadfa3;font-weight:bold;background:#030307;padding:5px;";
    const toolsInfoStyle2 = "color:#FFFFFF;font-weight:bold;background:green;padding:5px;";
    const toolsInfoStyle3 = "color:#0000ff;font-weight:bold;background:pink;padding:5px;";
    MyComponent.prototype = {
      _setModel: function(model) {
        this.model = model;

        const _storeKey = "_store_" + model.pageId + "_" + model.key;
        window[_storeKey] = createStore();
        this.store = window[_storeKey];
        this.store.commit("set_noDataMsg", KDApi.getLangMsg(this.model, "noDataMsg"));
        window[_storeKey]._invoke = function() {
          return model.invoke(arguments[0], arguments[1]);
        };
        window[_storeKey]._invokeAsync = function() {
          return model.invokeAsync(arguments[0], arguments[1]);
        };
      },
      init: function(props) {
        console.log(`-----init-----%c${name}%c${description}`, toolsInfoStyle1, toolsInfoStyle3, this.model, props, Date.now());

        /* const demoKey = KDApi.getLangMsg(this.model, "demoKey"); console.log(demoKey); // 多语言取字段 */
        /* const paramsMap = props.data;
        if (!paramsMap && typeof paramsMap != "object") return; */
        KDApi.loadFile(["src/css/app.css"], this.model, () => {
          const model = this.model;
          setHtml(model);
        });
      },
      update: function(props) {
        console.log(`-----update-----%c${name}%c${version}%c${lastTime}`, toolsInfoStyle1, toolsInfoStyle2, toolsInfoStyle3, this.model, props, Date.now());

        callBack(this.model, props, this.store);
      },
      destoryed: function() {
        console.log(`-----destoryed-----%c${name}%c${version}%c${lastTime}`, toolsInfoStyle1, toolsInfoStyle2, toolsInfoStyle3, this.model, Date.now());

        const _uuid = this.model.pageId + "_" + this.model.key;
        window[_uuid] = null;
        window["_store_" + _uuid] = null;
        this.store = null;
      },
    };

    // 注册自定义组件
    KDApi.register(name, MyComponent, {
      isMulLang: true,
    });
  } else {
    const store = createStore();
    const _now = Date.now();
    const model = {
      timestamp: _now,
      pageId: "mockPageId-",
      key: "ganttctl",
      dom: "#app",
      desc: "mock model " + _now,
    };
    // 添加本地实现平台内效果特殊处理方案
    const invoke = function(event, arg, exArg, _store) {
      console.log(`苍穹调用:\n方法名: ${event} \n参数: ${(typeof arg === "object" ? JSON.stringify(arg) : arg + "").substring(0, 1500)}`);
    };
    store._invoke = invoke;

    // 实例化
    const { dom } = model;
    const _uuid = model.pageId + "_" + model.key;
    window.kd = window[_uuid] = new Vue({
      el: dom,
      data: {
        resizeObj: null,
      },
      created() {
        const _self = this;
        _self.$store.commit("set_noDataMsg", "暂无数据");
        _self.$axios({
          method: "post",
          url: "/api/init",
          data: {},
        })
          .then((res) => {
            if (res.data.success === true) {
              _self.$store.commit("setUuid", _uuid);
              const paramsMap = res.data;
              _self.$store.commit("set_data", paramsMap.data);
              console.log("Mock:", paramsMap, this.$store.state);
            }
          });
      },
      components: { App },
      template: `<App />`,
      methods: {
        resizeCb(info) {
          const { width } = info;
          this.$store.commit("set_totalWidth", width);
        },
      },
      store,
      mounted() {
        // console.log("初始化容器宽高");
        this.resizeObj = addResizeObserve(this.$el, this.resizeCb);
      },
      beforeDestroy() {
        if (this.resizeObj && this.resizeObj.removeResizeObserve) {
          this.resizeObj.removeResizeObserve();
          this.resizeObj = null;
          console.log("重置容器尺寸监听");
        }
      },
    });

  }

})(window.KDApi);
